import React from 'react'
import CmsLink from '../CmsLink'

const SectionCta = ({ section }) => {

  return (
    <section className='section-cta'>
      <h2 className='section-headline'>
        { section.headline }
      </h2>
      <p className='section-lead'>
        { section.lead_text }
      </p>
      <CmsLink object={section} className='btn btn-primary'/>
    </section>
  )
}

export default SectionCta
